'use client';
import dynamic from 'next/dynamic';
import type { ComponentType } from 'react';
import type { StockMapProps } from '../createStockPage';
import { StockMapLoading } from '../stockMapLoading';

// Client-only + lazy (mapbox + recharts run browser-only). ssr:false must live
// in a client component; the cast restores the prop type next/dynamic widens.
const BlackwingInventoryMap = dynamic(
  () => import('./blackwingMap').then((m) => m.BlackwingInventoryMap),
  {
    ssr: false,
    loading: () => <StockMapLoading />,
  },
);

export default BlackwingInventoryMap as ComponentType<StockMapProps>;
